module.exports = __webpack_public_path__ + "img/team-img2.058695fc.jpg";